<template lang="html">

  <section class="users">
    <div class="pageHeading">
      <v-container grid-list-md >
        <v-layout row wrap>
          <v-flex xs12 md3>
            <h2>Users</h2>
          </v-flex>
          <v-flex xs12 md5>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-flex>
            <v-flex md1>

            </v-flex>
            <v-flex md3 text-xs-center>
                <v-switch
                        v-model="showOnlyVerified"
                        label="Only show active (completed setup page)"
                ></v-switch>
            </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-layout column style="padding-top:16px">
      <v-data-table hide-actions :headers="headers" :items="usersList" :search="search"
                    :hide-headers="isMobile" :class="{mobile: isMobile}"
      >
        <template slot="items" slot-scope="props">
          <tr v-if="!isMobile">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>
            <td class="text-xs-left">{{ props.item.email }}</td>
            <td class="text-xs-left" v-bind:class="{ unsignedMandatory:  props.item.unsignedMandatory == true}">{{props.item.signedDocCount}} / {{props.item.docCount}}</td>

            <td class="text-xs-left">{{ props.item.trips}}</td>
            <td class="text-xs-left">{{ props.item.type }}</td>
            <td class="text-xs-left">{{ props.item.status }}</td>
            <td class="text-xs-left actionIcons">
              <i @click="$router.push('/Profile/'+props.item.id)" class="fas fa-user-edit"></i>
              <i v-if="$userData.permissions[0]=='admin'" @click="deleteUser(props.item.id, 'Are you sure you want to permanently remove user: (' + props.item.email + ')' + '? \n\n THIS IS NOT REVERSIBLE')" style="color: darkred" class="fas fa-ban"></i>
            </td>
          </tr>
          <tr v-else>
            <td>
              <ul class="flex-content">
                <li class="flex-item" >{{ props.item.name }}</li>
                <li class="flex-item">{{ props.item.email }}</li>
                <li class="flex-item" ></li>
                <li class="flex-item" >{{ props.item.phone }}</li>
                <li class="flex-item" data-label="Type">{{ props.item.type }}</li>
                <li class="flex-item" data-label="Status">{{ props.item.status }}</li>

              </ul>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-layout>





    <table-component v-if="1==2" table-class="fullWidthTable" filter-input-class="fullWidthTableFilter" filter-placeholder="Filter Results" :show-caption="false"
                     :data="[
          { userID: '23', fullName: 'Kevin Nguyen', emailAddress: 'johnbaird4085@gmail.com',
          phoneNumber: '417-555-5555', cityName: 'Tallahassee',
          userType: 'parent', currentStatus: 'Enabled'    }
 ]"
                     sort-by="userID"
                     sort-order="asc"
    >
      <table-column show="userID" label="User ID"></table-column>
      <table-column show="fullName" label="Full name"></table-column>
      <table-column show="phoneNumber" label="Phone No."></table-column>
      <table-column show="cityName" label="City"></table-column>
      <table-column show="userType" label="Type"></table-column>
      <table-column show="currentStatus" label="Status"></table-column>
      <table-column label="" :sortable="false" :filterable="false">
        <template slot-scope="row">
          <!--<a :href="`#${row.firstName}`">Edit</a>-->

          <v-btn   small color="primary">Edit</v-btn>
          <v-btn small color="error">Disable</v-btn>
        </template>
      </table-column>
    </table-component>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'users',
    props: [],
    mounted() {

        var vueThis = this;

        this.$services.users.find().then((result) => {
            vueThis.usersInSystem = result.data
            console.log('users list is', result)
        })
    },
    data() {
      return {
          showOnlyVerified: false,
          usersInSystem: [],
          selected: [],
          search: '',
          isMobile: false,
          headers: [
              {
                text: 'Name (full)',
                align: 'left',
                value: 'name'
              },
              {
                  text: 'Phone #',
                  value: 'phone'
              },
              {
                  text: 'Email',
                  value: 'email'
              },
              {
                  text: 'Signed/Total Docs',
                  value: 'unsignedDocCount'
              },
              {
                  text: 'Trip(s)',
              },
              {
                  text: 'Type',
                  value: 'type'
              },
              {
                  text: 'Status',
                  value: 'status'
              },
              {
                  text: '-------',
                  value: 'actions',
                  sortable: false
              }
          ]
      }
    },
    methods: {
        deleteUser(id, prompt, confirmed = false) {
            var vueThis = this;
            console.log('delete user called for', id)
            confirm(prompt) &&
            this.$services.users.remove(id /*'DJBMtSec5hIXykbP'*/, {query: {'force':confirmed}}).then((result) => {
                console.log('remove rresult is ', result)
                vueThis.usersInSystem = vueThis.usersInSystem.filter(function( user ) {
                    return user._id !== id;
                });
            }).catch((errs) => {
                console.log('remove error is ', errs)
                alert(errs.message)
            })

        }
    },
    computed: {
        usersList() {
            var toReturn = []
            this.usersInSystem.forEach((user) => {
                user.fullName = '(Pending)'

                if (user.firstName !== null && user.lastName !== null)
                    user.fullName = user.firstName + ' ' + user.lastName;

                console.log('fullname is', user.fullName)

                let status = ''

                if(user.isVerified && user.trips.length == 0) {
                    status = 'Verified'
                } else if (!user.isVerified) {
                    status = "Unverified"
                } else if (user.trips.length > 0) {
                    status = 'Active'
                } else if (user.disabled) {
                    status = "Disabled"
                }


                if (user.signedDocs != undefined) {

                }


                var toAdd = {
                    'docCount': 0,
                    'documents' : [],
                    'unsignedMandatory': false,
                    'signedDocCount': 0,
                    'unsignedDocCount': 0,
                    'name' : user.fullName,
                    'phone' : user.phone,
                    'email' : user.email,
                    'trips' : this.$structuredData.trips
                    .filter((trip) => user.trips.includes(trip._id)).map(trip => trip.tripID).join(', '),
                    'type' : user.permissions[0],
                    'status' : status,
                    'id': user._id
                }


                this.$structuredData.trips
                    .filter((trip) => user.trips.includes(trip._id)).forEach((trip) => {

                    if (trip.documents != undefined) {

                        trip.documents.forEach((document)=>{

                            toAdd.docCount++

                            var doc = {
                                name: document.name,
                                _id: document._id
                            }
                            doc.docType = document.mandatory == true ? 'Mandatory' : 'Optional'

                            if (user.signedDocs != undefined) {
                                let result = user.signedDocs.find((signedDoc) => signedDoc.form == doc._id)

                                if (result != undefined) {
                                    doc.signed = result.signed
                                    doc.file = result.file
                                    toAdd.signedDocCount++;
                                } else {
                                    doc.signed = false

                                }
                            } else {
                                doc.signed = false
                            }

                            toAdd.unsignedMandatory = (document.mandatory && !doc.signed)


                            toAdd.documents.push(doc)
                        })

                    }

                })


                toAdd.unsignedDocCount = toAdd.docCount -toAdd.signedDocCount

                if (!this.showOnlyVerified || (this.showOnlyVerified && toAdd.status == 'Active'))  {
                    toReturn.push(toAdd)
                }

            })

            console.log('this is real user list', toReturn)
            return toReturn
        }

    }
}
</script>

<style scoped lang="scss">
  .users {
    .unsignedMandatory {
      color: red !important;
    }
  }



  .mobile {
    color: #333;
  }

  @media screen and (max-width: 768px) {
    .mobile table.v-table tr {
      max-width: 100%;
      position: relative;
      display: block;
    }

    .mobile table.v-table tr:nth-child(odd) {
      border-left: 6px solid deeppink;
    }

    .mobile table.v-table tr:nth-child(even) {
      border-left: 6px solid cyan;
    }

    .mobile table.v-table tr td {
      display: flex;
      width: 100%;
      border-bottom: 1px solid #f5f5f5;
      height: auto;
      padding: 10px;
    }

    .mobile table.v-table tr td ul li:before {
      content: attr(data-label);
      padding-right: .5em;
      text-align: left;
      display: block;
      color: #999;

    }
    .v-datatable__actions__select
    {
      width: 50%;
      margin: 0px;
      justify-content: flex-start;
    }
    .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
      background: transparent;
    }

  }
  .flex-content {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-item {
    padding: 5px;
    width: 50%;
    height: 40px;
    font-weight: bold;
  }
  .actionIcons > .fas {
    cursor: pointer;
    display: inline;
  }
  .actionIcons > .fas:last-child {
    margin-left: 20px;
    margin-right: 0px;
  }
</style>
